import styled from "styled-components";

export const FormPassword = styled.form`
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
`;

export const Actions = styled.div`
    display: flex;
    align-items: center;

    label{
        flex: 1;
        text-align: right;
        color: gray;
        cursor: pointer;
        :hover{
            text-decoration-line: underline;
        }
    }
`;